<template>
  <div :class="`${rowClass} h-100`">
    <div :class="`${colClass} h-100`">
      <div class="card package h-100">
        <div v-if="activity.picture_url" class="text-center">
          <img :src="activity.picture_url" :alt="activity.picture_url" class="card-img-top" />
        </div>
        <div class="card-body">
          <div v-html="text"></div>
          <div v-if="activity.url" class="text-center my-4">
            <b-button
              variant="branded"
              class="text-nowrap"
              :href="activity.url"
              target="_blank"
            >
              {{ buttonText }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      block: Object,
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        currency: _.currency,
      }
    },
    computed: {
      activity() {
        return this.block.meta
      },
      text() {
        const placeholders = _.createPageBlockPlaceholders(this.block)
        return _.replacePlaceholders(this.block.text, placeholders)
      },
      buttonText() {
        return this.activity.price > 0 ? _.currency(this.activity.price) : trans('free')
      },
      rowClass() {
        return this.block.span_row ? _.getRowClass(this.block) : null
      },
      colClass() {
        return this.block.span_row ? _.getColClass(this.block) : null
      },
    },
  }
</script>